import { format } from "date-fns";
import React, { useContext, useEffect } from "react";
import { ResumeContext } from "../../../contexts/resumeContext";
import { iconMap } from "../../../utils/constants";
import { Location, Mail, Phone } from "../../Icons/Icons";
import "./Edgy.css";

export default ({ info }) => {
  const {
    setColorOptions,
    activeColor,
    setActiveColor,
    resumeHeadings,
    setImgSupported,
  } = useContext(ResumeContext);

  useEffect(() => {
    setColorOptions(["#EB635D", "#4C9F65", "#EF955B", "#4DA9B0"]);
    setActiveColor("#EB635D");
    setImgSupported(true);
  }, []);

  const {
    personalDetails,
    educationDetails,
    professionalDetails,
    skills,
    social,
    misc,
  } = info;

  const education = Object.values(educationDetails || {});
  const work = Object.values(professionalDetails || {});
  const userSkills = Object.values(skills || {});
  const socialLinks = Object.values(social || {});
  const { courses, hobbies, languages, references, internships, activities, projects } =
    misc || {};
  return (
    <div className="edgy">
      <div className="edgy__body">
        <div className="edgy__body__left">
          <div className="edgy__personal_details">
            <h1 className="edgy__name">
              {personalDetails?.firstName?.trim()}{" "}
              {personalDetails?.lastName?.trim()}
            </h1>
            <h2 className="edgy__job_title">{personalDetails?.jobTitle}</h2>
          </div>
          {personalDetails?.summary && (
            <div className="summary__section">
              <h3
                className="section__title"
                style={{ background: activeColor, borderColor: activeColor }}
              >
                {resumeHeadings?.SUM}
              </h3>
              <div
                style={{ background: activeColor }}
                className="section__content"
                dangerouslySetInnerHTML={{ __html: personalDetails?.summary }}
              />
            </div>
          )}
          {!!work?.length && (
            <div className="section">
              <h3
                className="section__title"
                style={{ borderColor: activeColor }}
              >
                {resumeHeadings?.WE}
              </h3>
              {work.map((exp, ix) => (
                <div className="sub__section">
                  <span
                    className="edgy__sq"
                    style={{ background: activeColor }}
                  ></span>
                  <p className="m-0">
                    <b>{exp.jobTitle}</b>
                  </p>
                  <p style={{ marginTop: "0.25em", marginBottom: 0 }}>
                    {exp.company}
                  </p>
                  <p style={{ marginTop: "0.5em" }}>
                    <em>
                      {exp.startDate && (
                        <>{format(new Date(exp.startDate), "MMM yyyy")}</>
                      )}{" "}
                      {exp.endDate && (
                        <>- {exp.endDate === "Present" ? "Present" : format(new Date(exp.endDate), "MMM yyyy")}</>
                      )}
                    </em>
                    <em style={{ float: "right" }}>{exp.location}</em>
                  </p>
                  <div dangerouslySetInnerHTML={{ __html: exp.description }} />
                </div>
              ))}
            </div>
          )}

          {!!internships?.length && (
            <div className="section">
              <h3
                className="section__title"
                style={{ borderColor: activeColor }}
              >
                {resumeHeadings?.INT}
              </h3>
              {internships.map((intern, ix) => (
                <div className="sub__section" key={`intern_${ix}`}>
                  <span
                    className="edgy__sq"
                    style={{ background: activeColor }}
                  ></span>
                  <p className="m-0">
                    <b>{intern.jobTitle}</b>, {intern.company}
                  </p>
                  <p style={{ marginTop: "0.5em" }}>
                    <em>
                      {intern.startDate && (
                        <>{format(new Date(intern.startDate), "MMM yyyy")}</>
                      )}{" "}
                      {intern.endDate && (
                        <>- {format(new Date(intern.endDate), "MMM yyyy")}</>
                      )}
                    </em>
                    <em style={{ float: "right" }}>{intern.location}</em>
                  </p>
                  <div
                    dangerouslySetInnerHTML={{ __html: intern.description }}
                  />
                </div>
              ))}
            </div>
          )}

          {!!education?.length && (
            <div className="section">
              <h3
                className="section__title"
                style={{ borderColor: activeColor }}
              >
                {resumeHeadings?.AD}
              </h3>
              {education?.map((ed, ix) => (
                <div className="sub__section">
                  <span
                    className="edgy__sq"
                    style={{ background: activeColor }}
                  ></span>
                  <p className="m-0">
                    <b>{ed.degree}</b>, {ed.institute}
                  </p>
                  <p style={{ marginTop: "0.5em" }}>
                    <em>
                      {ed.startDate && (
                        <>{format(new Date(ed.startDate), "MMM yyyy")}</>
                      )}{" "}
                      {ed.endDate && (
                        <>- {format(new Date(ed.endDate), "MMM yyyy")}</>
                      )}
                    </em>
                    <em style={{ float: "right" }}>{ed.location}</em>
                  </p>
                  <div dangerouslySetInnerHTML={{ __html: ed.description }} />
                </div>
              ))}
            </div>
          )}

          {!!projects?.length && (
            <div className="section">
              <h3
                className="section__title"
                style={{ borderColor: activeColor }}
              >
                {resumeHeadings?.PRO}
              </h3>
              {projects?.map((pro, ix) => (
                <div className="sub__section">
                  <span
                    className="edgy__sq"
                    style={{ background: activeColor }}
                  ></span>
                  <p className="m-0">
                    <b>{pro.title}</b>, {pro.company}
                  </p>
                  <p style={{ marginTop: "0.5em" }}>
                    <em>
                      {pro.startDate && (
                        <>{format(new Date(pro.startDate), "MMM yyyy")}</>
                      )}{" "}
                      {pro.endDate && (
                        <>- {format(new Date(pro.endDate), "MMM yyyy")}</>
                      )}
                    </em>
                  </p>
                  <div dangerouslySetInnerHTML={{ __html: pro.description }} />
                </div>
              ))}
            </div>
          )}

          {!!courses?.length && (
            <div className="section">
              <h3
                className="section__title"
                style={{ borderColor: activeColor }}
              >
                {resumeHeadings?.CR}
              </h3>
              {courses?.map((course, ix) => (
                <div className="sub__section">
                  <span
                    className="edgy__sq"
                    style={{ background: activeColor }}
                  ></span>
                  <p className="m-0">
                    <b>{course.name}</b>
                  </p>
                  <p style={{ marginTop: "0.5em" }}>
                    {course.institution},&nbsp;
                    <em>
                      (
                      {course.startDate && (
                        <>{format(new Date(course.startDate), "MMM yyyy")}</>
                      )}{" "}
                      {course.endDate && (
                        <>- {format(new Date(course.endDate), "MMM yyyy")}</>
                      )}
                      )
                    </em>
                  </p>
                </div>
              ))}
            </div>
          )}

          {!!activities?.length && (
            <div className="section">
              <h3
                className="section__title"
                style={{ borderColor: activeColor }}
              >
                {resumeHeadings?.ACT}
              </h3>
              {activities?.map((activity, ix) => (
                <div className="sub__section" key={ix}>
                  <span
                    className="edgy__sq"
                    style={{ background: activeColor }}
                  ></span>
                  <p className="m-0">
                    <b>{activity.title}</b>, {activity.institution}
                  </p>
                  <p style={{ marginTop: "0.5em" }}>
                    <em>
                      {activity.startDate && (
                        <>{format(new Date(activity.startDate), "MMM yyyy")}</>
                      )}{" "}
                      {activity.endDate && (
                        <>- {format(new Date(activity.endDate), "MMM yyyy")}</>
                      )}
                    </em>
                    <em style={{ float: "right" }}>{activity.location}</em>
                  </p>
                  <div
                    dangerouslySetInnerHTML={{ __html: activity.description }}
                  />
                </div>
              ))}
            </div>
          )}

          {!!references?.length && (
            <div className="section">
              <h3
                className="section__title"
                style={{ borderColor: activeColor }}
              >
                {resumeHeadings?.REF}
              </h3>
              {references?.map((ref, ix) => (
                <div className="sub__section" key={ix}>
                  <span
                    className="edgy__sq"
                    style={{ background: activeColor }}
                  ></span>
                  <p className="m-0">
                    <b>{ref.name}</b>, {ref.institution}
                  </p>
                  <p style={{ marginTop: "0.5em" }}>
                    {ref.email}
                    {ref.phone && <>, {ref.phone}</>}
                  </p>
                </div>
              ))}
            </div>
          )}
        </div>
        <div className="edgy__body__right">
          <div className="section edgy__avatar">
            {personalDetails?.userImage && (
              <img src={personalDetails?.userImage} />
            )}
          </div>
          <div className="section">
            <h3 className="section__title" style={{ borderColor: activeColor }}>
              Contact
            </h3>
            <div className="row">
              <div className="contact__content">
                {personalDetails?.email && (
                  <span>
                    <a href={`mailto:${personalDetails?.email?.trim()}`}>
                      <i>
                        <Mail style={{ color: activeColor }} />
                      </i>{" "}
                      {personalDetails?.email?.trim()}
                    </a>
                  </span>
                )}
                {personalDetails?.phone && (
                  <span>
                    <a href={`tel:${personalDetails?.phone?.trim()}`}>
                      <i>
                        <Phone style={{ color: activeColor }} />
                      </i>{" "}
                      {personalDetails?.phone?.trim()}
                    </a>
                  </span>
                )}
                {(personalDetails?.address?.trim() ||
                  personalDetails?.postalCode?.trim()) && (
                  <span>
                    <i>
                      <Location style={{ color: activeColor }} />
                    </i>
                    {personalDetails?.address?.trim()}
                    {personalDetails?.postalCode?.trim() && " - "}
                    {personalDetails?.postalCode?.trim()}
                  </span>
                )}
                {socialLinks.map((link, ix) =>
                  link.link !== "" ? (
                    <span>
                      <a href={link.link} target="_blank">
                        <i style={{ color: activeColor }}>
                          {iconMap[link.label?.toLowerCase()] || link.label}
                        </i>{" "}
                        {link.link}
                      </a>
                    </span>
                  ) : null
                )}
              </div>
            </div>
          </div>

          {!!userSkills?.length && (
            <div className="section">
              <h3
                className="section__title"
                style={{ borderColor: activeColor }}
              >
                {resumeHeadings?.SK}
              </h3>
              <div className="section__content">
                {userSkills.map((skill, ix) => (
                  <span
                    className="edgy__skill"
                    key={skill + ix}
                    style={{ backgroundColor: activeColor }}
                  >
                    {skill}
                  </span>
                ))}
              </div>
            </div>
          )}

          {!!hobbies?.length && (
            <div className="section">
              <h3
                className="section__title"
                style={{ borderColor: activeColor }}
              >
                {resumeHeadings?.HOB}
              </h3>
              <div className="section__content">{hobbies}</div>
            </div>
          )}
          {!!languages?.length && (
            <div className="section">
              <h3
                className="section__title"
                style={{ borderColor: activeColor }}
              >
                {resumeHeadings?.LAN}
              </h3>
              <div className="section__content">{languages}</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
